var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-marker-container"},[_vm._v(" "+_vm._s(`監視器名稱: ${_vm.file.content.split('-')[1]}`)+" "),_c('el-image',{attrs:{"src":_vm.file.url}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }